import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Confirm } from 'semantic-ui-react';
import { useDebounce } from 'use-debounce';
import { quanHeGiaDinhApi } from '../../../api/quanHeGiaDinhApi';
import { DangerButton, DefaultButton } from '../../../components/editor/button';
import PlaceHolder from '../../../components/place-holder';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import styles from './QuanHeGiaDinhHocSinh.module.css';
import QuanHeGiaDinhEditModal from './detail-modal/QuanHeGiaDinhEditModal';
import SwitchBox from 'devextreme-react/switch';
import { phuHuynhApi } from '../../../api/phuHuynhApi';
import { formRegisterApi } from '../../../api/formRegisterApi';
import { useSelector } from 'react-redux';
import { userApi } from '../../../api/userApi';

const quanHeGroups = [
	{ idx: 1, text: 'Phụ huynh', dm_quanhe_ids: [1, 2] },
	{ idx: 2, text: 'Anh/ Chị/ Em', dm_quanhe_ids: [5, 6] },
	{ idx: 3, text: 'Khác', dm_quanhe_ids: [0, 3, 4] },
];
const QuanHeGiaDinhHocSinh = ({ phuHuynh, hocSinh, height }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [quanHeGiaDinhs, setQuanHeGiaDinhs] = useState([]);
	const [isShowPlaceHolder] = useDebounce(isLoading, 200);
	const [editingQuanHeGiaDinh, setEditingQuanHeGiaDinh] = useState();
	const [isShowDetailModal, setIsShowDetailModal] = useState(false);
	const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false);
	const { dm_coso_id } = useSelector((x) => x.coSo);

	const { translate } = useCommonContext();

	const componentDidMount = useRef(false);
	useEffect(() => {
		componentDidMount.current = true;
		handleGetQuanHeGiaDinhs();
		return () => {
			componentDidMount.current = false;
		};
	}, [hocSinh]);
	const handleGetQuanHeGiaDinhs = async () => {
		setIsLoading(true);
		const res = await quanHeGiaDinhApi.SelectByHocSinh(hocSinh.id);
		if (!componentDidMount.current) return;
		setIsLoading(false);
		if (res.is_success) {
			var data = res.data;
			try {
				for (let index = 0; index < data.length; index++) {
					const element = data[index];
					if(element.ts_phuhuynh.user_tu_van_id>0){
						const res = await userApi.Detail(element.ts_phuhuynh.user_tu_van_id);
						if (res.is_success) {
							data[index].ts_phuhuynh.user_tu_van_full_name = res.data.full_name;
						}
					}
					
				}
			} catch (error) {
				
			}
			
			setQuanHeGiaDinhs(data);
		}
	};
	const handleDeleteQuanHeGiaDinh = async () => {
		const res = await quanHeGiaDinhApi.Delete(editingQuanHeGiaDinh.id);
		if (!componentDidMount.current) return;
		if (res.is_success) {
			handleGetQuanHeGiaDinhs();
			setIsShowDeleteConfirm(false);
		} else {
			showNotify({
				type: 'error',
				text: 'Có lỗi xảy ra',
			});
		}
	};
	const dataSource = useMemo(() => {
		var source = quanHeGroups.map((group) => {
			const data = quanHeGiaDinhs.filter((x) => group.dm_quanhe_ids.includes(x.dm_quanhe_id));
			return {
				...group,
				data: data,
			};
		});
		return source.filter((x) => x.data.length > 0);
	}, [quanHeGroups, quanHeGiaDinhs]);
	// console.log(dataSource, 'dataSource')
	return (
		<div style={{ paddingLeft: 10 }}>
			<div>
				<div className={styles.actions}>
					<Button
						text={translate('Thêm phụ huynh, người giám hộ')}
						type='default'
						stylingMode='text'
						onClick={() => {
							setEditingQuanHeGiaDinh();
							setIsShowDetailModal(true);
						}}
					/>
				</div>
				{isShowPlaceHolder && <PlaceHolder line_number={10} />}
				{!isShowPlaceHolder && (
					<div className={styles.list_group}>
						{dataSource.map((x, idx) => {
							return (
								<div key={idx} className={styles.group_container}>
									<div className={styles.group_caption}>{x.text}</div>
									<div className={styles.list_container}>
										{x.data.map((quan_he, idx) => {
											return (
												<div key={idx} className={styles.item_container}>
													{quan_he.ts_hocsinh_ace && <HocSinhInfo ts_hocsinh={quan_he.ts_hocsinh_ace} />}
													{quan_he.ts_phuhuynh && (
														<PhuHuynhInfo
															ts_phuhuynh={quan_he.ts_phuhuynh}
															is_uutien={quan_he.is_uutien}
															// isAllowEditing={x.idx == 3}
															isAllowEditing={true}
															onDeleteClick={() => {
																setEditingQuanHeGiaDinh(quan_he);
																setIsShowDeleteConfirm(true);
															}}
															onEditClick={() => {
																setEditingQuanHeGiaDinh(quan_he);
																setIsShowDetailModal(true);
															}}
														/>
													)}
												</div>
											);
										})}
									</div>
								</div>
							);
						})}
					</div>
				)}
				{isShowDetailModal && (
					<QuanHeGiaDinhEditModal
						ts_hocsinh_id={hocSinh.id}
						id={editingQuanHeGiaDinh != null ? editingQuanHeGiaDinh.id : 0}
						onSuccess={() => {
							setIsShowDetailModal(false);
							handleGetQuanHeGiaDinhs();
						}}
						onCancel={() => {
							setIsShowDetailModal(false);
						}}
					/>
				)}
				{isShowDeleteConfirm && (
					<Confirm
						className={styles.modal_center}
						open={true}
						dimmer={'blurring'}
						header={translate('Lưu ý')}
						content={translate('Bạn có chắc chắn muốn xóa Quan hệ gia đình này ?')}
						size='mini'
						cancelButton={() => {
							return (
								<DefaultButton
									text={'Đóng'}
									onClick={() => {
										setIsShowDeleteConfirm(false);
									}}
								/>
							);
						}}
						confirmButton={() => {
							return (
								<>
									<DangerButton
										text={'Xóa'}
										onClick={() => {
											handleDeleteQuanHeGiaDinh();
										}}
									/>
								</>
							);
						}}
					/>
				)}
			</div>
		</div>
	);
};
const PhuHuynhInfo = ({ ts_phuhuynh, is_uutien, isAllowEditing, onDeleteClick, onEditClick }) => {
	return (
		<>
			<div className={styles.caption}>
				<div className={styles.name}>{ts_phuhuynh.ho_ten}</div>
				<span className={styles.tag}>{ts_phuhuynh.quan_he}</span>
				{isAllowEditing && (
					<DropDownButton
						text=''
						icon='overflow'
						dropDownOptions={{ width: 90 }}
						displayExpr='name'
						keyExpr='id'
						stylingMode='text'
						items={[
							{ id: 1, name: 'View', icon: 'edit' },
							{ id: 2, name: 'Xóa', icon: 'trash' },
						]}
						onItemClick={(e) => {
							// console.log({ e });
							if (e.itemData.id == 1) onEditClick();
							if (e.itemData.id == 2) onDeleteClick();
						}}
					/>
				)}
			</div>
			<p className={styles.info_container}>
				<i className='fas fa-at'></i>
				Email <b>{ts_phuhuynh.email}</b>
			</p>
			<p className={styles.info_container}>
				<i className='fas fa-phone'></i>
				Điện thoại liên hệ <b>{ts_phuhuynh.dien_thoai}</b>
			</p>
			<p className={styles.info_container}>
				<i className='fas fa-address-card'></i>
				Tư vấn viên <b>{ts_phuhuynh.user_tu_van_full_name}</b>
			</p>
			<p style={{ paddingLeft: 30, display: 'flex', alignItems: 'center' }}>
				<Link target={'_blank'} to={`../../phu-huynh/${ts_phuhuynh.id}`}>
					Xem lịch sử chăm sóc <i className='fas fa-chevron-right'></i>
				</Link>
				{is_uutien && <span style={{ marginLeft: 'auto' }}><b>Liên hệ chính</b></span>}
			</p>
		</>
	);
};
const HocSinhInfo = ({ ts_hocsinh }) => {
	return (
		<>
			<div className={styles.caption}>
				<div className={styles.name}>{ts_hocsinh.ho_ten}</div>
				<span className={styles.tag}>{ts_hocsinh.trang_thai}</span>
			</div>

			<div className={styles.info_container}>
				<p style={{ flex: 1 }}>
					<i className='fas fa-tasks'></i>
					<>
						<b>{ts_hocsinh.ma_hs}</b>
					</>
				</p>
				<p style={{ flex: 1 }}>
					<i className='fas fa-tasks'></i>
					<>{ts_hocsinh.ma_tn}</>
				</p>
			</div>
			<div className={styles.info_container}>
				<p style={{ flex: 1 }}>
					<i className='fas fa-birthday-cake'></i>
					<>{moment(ts_hocsinh.ngay_sinh).format('DD/MM/YYYY')}</>
				</p>
				<p style={{ flex: 1 }}>
					{ts_hocsinh.dm_gioitinh_id == 1 && <i className='fas fa-male'></i>}
					{ts_hocsinh.dm_gioitinh_id == 2 && <i className='fas fa-female'></i>}
					<>{ts_hocsinh.gioi_tinh}</>
				</p>
			</div>
			<div className={styles.info_container}>
				<p style={{ flex: 1 }}>
					<i className='fas fa-tasks'></i>
					Hệ <>{ts_hocsinh.ten_he}</>
				</p>
				<p style={{ flex: 1 }}>
					<i className='fas fa-door-open'></i>
					Lớp <>{ts_hocsinh.ten_lop}</>
				</p>
			</div>
		</>
	);
};
export default QuanHeGiaDinhHocSinh;
